import _util from '../../utils/';


const ApprovalAccessService = {
	selectApprovalAccess(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowStatusWithRole/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	deleteApprovalAccess(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasisRole/BatchDelete',
			method: "delete",
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateApprovalAccess(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasisRole/Put',
			method: "put",
			data: data,
			success: resolve,
			error: reject
		})
	},
	createApprovalAccess(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasisRole/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	initiaApprovalAccess(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasisRole/Init',
			params: data,
			success: resolve,
			error: reject
		})
	},
	detailApprovalAccess(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalFlowBasisRole/Details',
			params: data,
			success: resolve,
			error: reject
		})
	}
};


export default ApprovalAccessService;




// WEBPACK FOOTER //
// ./src/services/Approval/approval-access-service.js